(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["misell-horizontal-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.misell-horizontal-list-section').forEach((section) => {
      const container = section.querySelector('.product-list-container');
      if (!container) return;

      const indicator = document.createElement('div');
      indicator.className = 'scroll-hover-indicator';
      document.body.appendChild(indicator);

      let isScrolling = false;
      let startX;
      let startY;
      let scrollLeft;
      let isDragging = false;
      let startTime;
      let lastScrollTime = 0;
      let isHorizontalScroll = false;
      const SCROLL_THROTTLE = 8; // より高頻度な更新
      const SCROLL_THRESHOLD = 3; // より敏感な反応
      const VELOCITY_MULTIPLIER = 1.5; // スクロール速度の調整

      // 慣性スクロール用の変数
      let velocityX = 0;
      let lastX = 0;
      let lastTimestamp = 0;
      let animationFrameId = null;

      function momentumScroll(timestamp) {
        if (!lastTimestamp) lastTimestamp = timestamp;
        const deltaTime = timestamp - lastTimestamp;
        lastTimestamp = timestamp;

        if (Math.abs(velocityX) < 0.2) {
          cancelAnimationFrame(animationFrameId);
          return;
        }

        // 速度に応じて動的に減速率を調整
        const speed = Math.abs(velocityX);
        const baseDeceleration = 0.97;
        const speedFactor = Math.min(speed / 30, 1);
        const deceleration = baseDeceleration - 0.03 * speedFactor;

        // より滑らかな移動のために deltaTime を考慮
        const movement = (velocityX * deltaTime) / 16;
        container.scrollLeft += movement;
        velocityX *= deceleration;

        // スクロール範囲の制限とバウンス効果
        if (container.scrollLeft <= 0) {
          container.scrollLeft = 0;
          velocityX = Math.abs(velocityX) * 0.02; // バウンス効果をより弱める
        } else if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
          container.scrollLeft = container.scrollWidth - container.clientWidth;
          velocityX = -Math.abs(velocityX) * 0.02; // バウンス効果をより弱める
        }

        animationFrameId = requestAnimationFrame(momentumScroll);
      }

      container.addEventListener('mousedown', (e) => {
        if (e.target.closest('.cart-button')) return;
        e.preventDefault();
        document.getSelection().removeAllRanges();

        cancelAnimationFrame(animationFrameId);
        velocityX = 0;

        startTime = Date.now();
        isScrolling = true;
        isDragging = false;
        container.style.cursor = 'grabbing';
        startX = lastX = e.pageX;
        lastTimestamp = Date.now();
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener('mousemove', (e) => {
        if (!isScrolling) return;
        const currentTime = Date.now();
        if (currentTime - lastScrollTime < SCROLL_THROTTLE) return;

        e.preventDefault();
        isDragging = true;

        const deltaX = lastX - e.pageX;
        const deltaTime = currentTime - lastTimestamp;
        velocityX = (deltaX / deltaTime) * VELOCITY_MULTIPLIER * 16;

        const x = e.pageX - container.offsetLeft;
        const walk = (startX - x) * 1.5; // スクロール距離の調整
        container.scrollLeft = scrollLeft + walk;

        lastX = e.pageX;
        lastTimestamp = currentTime;
        lastScrollTime = currentTime;
      });

      container.addEventListener('mouseup', (e) => {
        const timeElapsed = Date.now() - startTime;
        if (!isDragging && timeElapsed < 200) {
          const link = e.target.closest('a');
          if (link && !e.target.closest('.cart-button')) {
            window.location.href = link.href;
          }
        }

        isScrolling = false;
        container.style.cursor = 'grab';

        lastTimestamp = null;
        if (Math.abs(velocityX) > 0.1) {
          animationFrameId = requestAnimationFrame(momentumScroll);
        }
      });

      let lastTouchX = 0;
      let totalScrollDistance = 0;
      const SCROLL_DISTANCE_THRESHOLD = 30;

      let touchStartTarget = null;
      let preventClick = false;
      let touchStartLink = null;

      container.addEventListener(
        'touchstart',
        (e) => {
          if (e.target.closest('.cart-button')) return;

          touchStartLink = e.target.closest('a');

          cancelAnimationFrame(animationFrameId);
          velocityX = 0;
          totalScrollDistance = 0;
          preventClick = false;

          startTime = Date.now();
          startX = lastTouchX = e.touches[0].pageX;
          startY = e.touches[0].pageY;
          lastTimestamp = Date.now();
          scrollLeft = container.scrollLeft;
          isHorizontalScroll = false;
        },
        { passive: false }
      );

      container.addEventListener(
        'touchmove',
        (e) => {
          if (!startX || !startY) return;

          const x = e.touches[0].pageX;
          const y = e.touches[0].pageY;
          const deltaX = Math.abs(x - startX);
          const deltaY = Math.abs(y - startY);

          if (!isHorizontalScroll && (deltaX > SCROLL_THRESHOLD || deltaY > SCROLL_THRESHOLD)) {
            isHorizontalScroll = deltaX > deltaY;

            if (isHorizontalScroll) {
              preventClick = true;
              e.preventDefault();
            } else {
              startX = null;
              startY = null;
              return;
            }
          }

          if (isHorizontalScroll) {
            e.preventDefault();
            const currentTime = Date.now();
            const deltaX = lastTouchX - e.touches[0].pageX;
            const deltaTime = currentTime - lastTimestamp;
            velocityX = (deltaX / deltaTime) * VELOCITY_MULTIPLIER * 16;

            const walk = (startX - x) * 1.3; // タッチスクロールの感度調整
            container.scrollLeft = scrollLeft + walk;

            totalScrollDistance += Math.abs(deltaX);
            lastTouchX = e.touches[0].pageX;
            lastTimestamp = currentTime;
          }
        },
        { passive: false }
      );

      container.addEventListener(
        'click',
        (e) => {
          if (preventClick) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      container.addEventListener('touchend', (e) => {
        const timeElapsed = Date.now() - startTime;
        const endLink = e.target.closest('a');

        if (
          !preventClick &&
          touchStartLink &&
          endLink &&
          touchStartLink === endLink &&
          timeElapsed < 300 &&
          !e.target.closest('.cart-button')
        ) {
          window.location.href = endLink.href;
        }

        startX = null;
        startY = null;
        isHorizontalScroll = false;
        totalScrollDistance = 0;
        touchStartTarget = null;

        lastTimestamp = null;
        if (Math.abs(velocityX) > 0.1) {
          animationFrameId = requestAnimationFrame(momentumScroll);
        }

        setTimeout(() => {
          preventClick = false;
        }, 100);
      });

      function updateScrollButtons() {
        const prevButton = section.querySelector('.scroll-prev');
        const nextButton = section.querySelector('.scroll-next');
        if (prevButton && nextButton) {
          prevButton.disabled = container.scrollLeft <= 0;
          nextButton.disabled = container.scrollLeft >= container.scrollWidth - container.clientWidth;
        }
      }

      section.querySelector('.scroll-prev')?.addEventListener('click', () => {
        const columnWidth = getColumnWidth();
        container.scrollTo({
          left: container.scrollLeft - columnWidth,
          behavior: 'smooth',
        });
      });

      section.querySelector('.scroll-next')?.addEventListener('click', () => {
        const columnWidth = getColumnWidth();
        container.scrollTo({
          left: container.scrollLeft + columnWidth,
          behavior: 'smooth',
        });
      });

      function getColumnWidth() {
        const productItem = section.querySelector('.horizontal-list-item');
        return productItem ? productItem.offsetWidth + 8 : 0;
      }

      container.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons);
      updateScrollButtons();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
